import useSWRImmutable from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILocationBin } from '../../components/marking/MarkingInterfaces';

const GetNonCourierBinNames = ():{ binNames: ILocationBin[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILocationBin[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWRImmutable<ILocationBin[], AxiosError>('/RepairLookup/GetNonCourierBinNames',
    (url) => fetcher(url));

  return {
    binNames: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetNonCourierBinNames;
